import { getIsGretaAIChatFinanceSource } from '../../../GretaAIChat.utils.source'
import { useGretaAIChatChatListLoader } from '../../useGretaAIChatChatListLoader'
import { useGretaAIChatRowStatus } from '../../useGretaAIChatRowStatus'

export function useGretaAIChatSessionChats({
  activeChatId,
  activeChatIdRef,
  isLocked,
  isMinimized,
  isOpen,
  markFinanceUsed,
  openChat,
  setActiveChatId,
}) {
  const chatListLoader = useGretaAIChatChatListLoader({
    activeChatId,
    isMinimized,
    isOpen: isOpen && !isLocked,
    onActiveChatMissing: handleChatMissing,
  })
  const {
    activeChat,
    addChat,
    chats,
    dropChat,
    getIsChatGenerationSettledRecently,
    refreshChats,
    settleChatGeneration,
  } = chatListLoader

  const {
    chatStatusById,
    clearChatUnread,
    markChatGenerating,
    markChatSettled,
  } = useGretaAIChatRowStatus({ chats })

  function handleChatCreated({ chatData, chatId, shouldActivate }) {
    if (shouldActivate) {
      setActiveChatId(chatId)
    }

    if (getIsGretaAIChatFinanceSource(chatData.source)) {
      markFinanceUsed()
    }

    addChat(chatData)
    refreshChats()
  }

  // Clear only if the probed/loaded chat is still the open one — a slow probe must
  // not drop a selection the user has since moved to another chat.
  function handleChatMissing(chatId) {
    if (chatId === undefined || chatId === activeChatIdRef.current) {
      setActiveChatId(null)
    }

    if (chatId !== undefined) {
      dropChat(chatId)
    }
  }

  function handleSelectChat(chatId) {
    clearChatUnread(chatId)
    openChat(chatId)
  }

  return {
    activeChat,
    chatListLoader,
    chats,
    chatStatusById,
    clearChatUnread,
    getIsChatGenerationSettledRecently,
    handleChatCreated,
    handleChatMissing,
    handleSelectChat,
    markChatGenerating,
    markChatSettled,
    settleChatGeneration,
  }
}
